(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    const color = '#c80000';
    const scopeSelector = 'variant-swatch-king, .swatch-drop-down, .swatch-view, .swatch-single';

    const paintLineThroughs = (root) => {
      const nodes = [root, ...root.querySelectorAll('*')];

      nodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        const styles = window.getComputedStyle(node);
        const decorationLine = styles.textDecorationLine || styles.webkitTextDecorationLine || '';
        const decoration = styles.textDecoration || '';

        if (!decorationLine.includes('line-through') && !decoration.includes('line-through')) return;

        node.style.setProperty('text-decoration-color', color, 'important');
        node.style.setProperty('-webkit-text-decoration-color', color, 'important');
      });
    };

    const bindScope = (root) => {
      if (!(root instanceof Element)) return;

      if (root.dataset.abrisRedStrikeBound === 'true') {
        paintLineThroughs(root);
        return;
      }

      root.dataset.abrisRedStrikeBound = 'true';

      let frame = 0;
      const schedule = () => {
        window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(() => paintLineThroughs(root));
      };

      const observer = new MutationObserver(schedule);
      observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'aria-disabled', 'data-available', 'data-option-available']
      });

      root.addEventListener('click', () => {
        schedule();
        window.setTimeout(schedule, 40);
        window.setTimeout(schedule, 140);
      });

      schedule();
    };

    const bindAll = (scope = document) => {
      scope.querySelectorAll(scopeSelector).forEach(bindScope);

      if (scope instanceof Element && scope.matches(scopeSelector)) {
        bindScope(scope);
      }
    };

    const start = () => {
      bindAll();

      if (window.__abrisSwatchKingStrikeFix) return;

      window.__abrisSwatchKingStrikeFix = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (!(node instanceof Element)) return;
            bindAll(node);
          });
        });
      });

      window.__abrisSwatchKingStrikeFix.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
